import React, { useState, useEffect } from 'react';
import qyeryString from "query-string";

import TestMenu from "./TestMenu";
import CommonTest from "./CommonTest";
import PincodeTest from "./PincodeTest";
import KeypadTest from "./KeypadTest";
import PhotoUploadTest from "./PhotoUploadTest";
import AddressUploadTest from "./AddressUploadTest";
import EtcTest from "./EtcTest";
import RailplusTest from "./RailplusTest";
import { useLocation } from 'react-router';

const AppTestPage = () => {
    const location = useLocation();

    const query = qyeryString.parse(location.search);

    const [isMain, setMain] = useState(true);
    const [isCommon, setCommon] = useState(false);
    const [isPincode, setPincode] = useState(false);
    const [isKeypad, setKeypad] = useState(false);
    const [isPhotoUpload, setPhotoUpload] = useState(false);
    const [isAddressUpload, setAddressUpload] = useState(false);
    const [isEtc, setEtc] = useState(false);
    const [isRailplus, setRailplus] = useState(false);

    useEffect(() => {
      if (isMain) {
        setCommon(false);
        setPincode(false);
        setKeypad(false);
        setPhotoUpload(false);
        setAddressUpload(false);
        setEtc(false);
        setRailplus(false);
      }
    }, [isMain]);

    useEffect(() => {
      if (isCommon) {
        setMain(false);
        setPincode(false);
        setKeypad(false);
        setPhotoUpload(false);
        setAddressUpload(false);
        setEtc(false);
        setRailplus(false);
      }
    }, [isCommon]);

    useEffect(() => {
      if (isPincode) {
        setMain(false);
        setCommon(false);
        setKeypad(false);
        setPhotoUpload(false);
        setAddressUpload(false);
        setEtc(false);
        setRailplus(false);
      }
    }, [isPincode]);

    useEffect(() => {
      if (isKeypad) {
        setMain(false);
        setCommon(false);
        setPincode(false);
        setPhotoUpload(false);
        setAddressUpload(false);
        setEtc(false);
        setRailplus(false);
      }
    }, [isKeypad]);

    useEffect(() => {
      if (isPhotoUpload) {
        setMain(false);
        setCommon(false);
        setPincode(false);
        setKeypad(false);
        setAddressUpload(false);
        setEtc(false);
        setRailplus(false);
      }
    }, [isPhotoUpload]);

    useEffect(() => {
      if (isAddressUpload) {
        setMain(false);
        setCommon(false);
        setPincode(false);
        setKeypad(false);
        setPhotoUpload(false);
        setEtc(false);
        setRailplus(false);
      }
    }, [isAddressUpload]);

    useEffect(() => {
      if (isEtc) {
        setMain(false);
        setCommon(false);
        setPincode(false);
        setKeypad(false);
        setPhotoUpload(false);
        setAddressUpload(false);
        setRailplus(false);
      }
    }, [isEtc]);

    useEffect(() => {
      if (isRailplus) {
        setMain(false);
        setCommon(false);
        setPincode(false);
        setKeypad(false);
        setPhotoUpload(false);
        setAddressUpload(false);
        setEtc(false);
      }
    }, [isRailplus]);

    return (
      <div id="container">
        <section className="contents" style={{overflow: "auto"}}>
          <div className="singUpWrapSub">
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={query.pid} readOnly />
                <span>pid</span>
              </label>
            </div>
            <div className="inputBoxWrapTy01" style={{overflow: "initial"}}>
              <div className="inputBoxTy01"> 
                <label className="mgb20">
                  <input type="text" value={query.languageCode} readOnly />
                  <span>languageCode</span>
                </label>
              </div>
              <div className="inputBoxTy01"> 
                <label className="mgb20">
                  <input type="text" value={query.inviterCode} readOnly />
                  <span>inviterCode</span>
                </label>
              </div>
            </div>
            <div className="inputBoxWrapTy01" style={{overflow: "initial"}}>
                <div className="inputBoxTy01"> 
                  <label className="mgb20">
                    <input type="text" value={query.deviceType} readOnly />
                    <span>deviceType</span>
                  </label>
                </div>
                <div className="inputBoxTy01"> 
                  <label className="mgb20">
                    <input type="text" value={query.trafficYn} readOnly />
                    <span>trafficYn</span>
                  </label>
                </div>
              </div>
          </div>
        </section>
        {isMain &&
          <TestMenu setMain={setMain} setCommon={setCommon} setPincode={setPincode} setKeypad={setKeypad} setPhotoUpload={setPhotoUpload} setAddressUpload={setAddressUpload} setEtc={setEtc} setRailplus={setRailplus}></TestMenu>
        }
        {isCommon &&
          <CommonTest setMain={setMain}></CommonTest>
        }
        {isPincode &&
          <PincodeTest setMain={setMain}></PincodeTest>
        }
        {isKeypad &&
          <KeypadTest setMain={setMain}></KeypadTest>
        }
        {isPhotoUpload &&
          <PhotoUploadTest setMain={setMain}></PhotoUploadTest>
        }
        {isAddressUpload &&
          <AddressUploadTest setMain={setMain}></AddressUploadTest>
        }
        {isEtc &&
          <EtcTest setMain={setMain}></EtcTest>
        }
        {isRailplus &&
          <RailplusTest setMain={setMain}></RailplusTest>
        }
      </div>
    );
}

export default AppTestPage;